// SuccessPopup.tsx
import Dones from "../../../../../assets/Images/success-image.png";
import { ModalWrapper } from "../../../../../shared/components/ModalWrapper";
import DoneActions from "./DoneActions";

interface Props {
  onSendMail: () => void;
  onSendMessage: () => void;
  onDone: () => void;
  printData: any;
  osb: number | string;
  disabled?: boolean;
  order: any
}

export default function SuccessPopup({ onSendMail, onSendMessage, onDone, printData, osb, disabled = false, order }: Props) {
  return (
    <ModalWrapper title="Payment Completed" className="min-w-[500px] text-center" width="max-w-xl w-full" showCloseButton={false} positionClass="top-0 left-0 right-0 mt-16 h-full">
      <div className="flex flex-col items-center text-center space-y-4">
        <img src={Dones} alt="success" className="w-48 h-48" />
        <p className="text-lg font-medium text-gray-700">Your payment has been completed successfully</p>

        <div className="mt-6 flex justify-center">
          <DoneActions
            onSendMail={onSendMail}
            onSendMessage={onSendMessage}
            onDone={onDone}
            printData={printData}
            osb={osb}
            disabled={disabled}
            order={order}
          />
        </div>
      </div>
    </ModalWrapper>
  );
}
